import { useCallback } from "react";
export default function useHandleMove(value, onChange) {
    return useCallback(function (source, dest) {
        if (source > (value === null || value === void 0 ? void 0 : value.length) || dest > (value === null || value === void 0 ? void 0 : value.length)) {
            return null;
        }
        const nv = [...value];
        [nv[source], nv[dest]] = [nv[dest], nv[source]];
        onChange(nv);
    }, [value, onChange]);
}
